import { Alert, Card, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Pagination, Zoom } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Campo } from "../../../componentes/form/campo";
import CardServico from "../../../componentes/servicos/cardServico";
import { Spinner } from "../../../componentes/Spinner";
import { ContextoGeral } from "../../../contextos/ContextoGeral";
import AppAPI from "../../../servicos/AppAPI";
import CardEndereco from "../../../componentes/form/CardEndereco";
import { MdClose, MdInfo } from "react-icons/md";

function dataHojeIso() {
    const d = new Date()
    const m = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${d.getFullYear()}-${m}-${day}`
}

function valoresIniciais(origemHome) {
    if (origemHome?.origemSaldoHome && origemHome?.visaoSaldo === "diario") {
        const hoje = dataHojeIso()
        return {
            idCliente: "todos",
            periodo: "intervalo",
            formaPgto: "todos",
            inicio: hoje,
            fim: hoje,
        }
    }
    return {
        idCliente: "todos",
        periodo: "mesAtual",
        formaPgto: "todos",
    }
}

export default function RelatorioConcluidos({ config, origemHome }) {
    const [listaConcluidos, setListaConcluidos] = useState('')
    const [totais, setTotais] = useState({})

    const [page, setPage] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [forma, setForma] = useState(0)

    const [intervalo, setIntervalo] = useState(() => valoresIniciais(origemHome).periodo === "intervalo")
    const [servicoSelecionado, setServicoSelecionado] = useState(null)

    const [valores, setValores] = useState(() => valoresIniciais(origemHome))

    const { dados } = useContext(ContextoGeral)

    const handleConfigBusca = async (e) => {
        let jsonValores = { ...valores }

        if (e.target.id == 'idCliente') {
            jsonValores.idCliente = e.target.value
        } else if (e.target.id == 'periodo') {
            jsonValores.periodo = e.target.value

            if (e.target.value == 'intervalo') {
                setIntervalo(true)
            } else {
                setIntervalo(false)
            }
        } else if (e.target.id == 'dataInicial') {
            jsonValores.inicio = e.target.value
        } else if (e.target.id == 'dataFinal') {
            jsonValores.fim = e.target.value
        } else if (e.target.id == 'formaPgto') {
            jsonValores.formaPgto = e.target.value
        }

        setValores(jsonValores)
    }

    async function buscarConcluidos() {
        setTotais({})
        setListaConcluidos(<Spinner />)
        let key = 0

        let retorno = await AppAPI.buscarRelatorioConcluidos(dados, valores, page)

        if (retorno.resultado && retorno.dados != '') {
            if (retorno.dados.formaBusca) setForma(retorno.dados.formaBusca)
            if (Array.isArray(retorno.dados.servicos)) {
                setTotalPages(parseInt(retorno.dados.servicosTotal.concluidos / 20) + 1)

                let lista = retorno.dados.servicos.map(concluido => {
                    key++
                    return <Zoom
                        key={`concluido-${key}`}
                        className="mt-3"
                        in={true}
                    >
                        <div>
                            <CardServico servico={concluido} setModal={setServicoSelecionado} obj={concluido} mostrarNomes />
                        </div>
                    </Zoom>
                })
                setListaConcluidos(lista)
                setTotais(retorno.dados.servicosTotal)
            }
        } else {
            setListaConcluidos(
                <Alert severity="error" className="text-center pb-3">
                    {retorno.mensagem}
                </Alert>
            )
        }
    }

    useEffect(() => {
        if (page > 0) buscarConcluidos()
    }, [page])

    useEffect(() => {
        if (origemHome?.origemSaldoHome) {
            setPage(1)
        }
    }, [origemHome?.origemSaldoHome])

    return <>
        <div className="mb-3">
            <div className="my-3">
                <div>
                    <Campo
                        id="idCliente"
                        tipo="select"
                        label={config.filtros.servicosConcluidos.cliente.label}
                        onChange={handleConfigBusca}
                        options={config.filtros.servicosConcluidos.cliente.opcoes}
                        obrigatorio={config.filtros.servicosConcluidos.cliente.obrigatorio}
                        value={valores.idCliente}
                    />
                </div>
                <div className="mt-3">
                    <Campo
                        id="periodo"
                        tipo="select"
                        label={config.filtros.servicosConcluidos.periodo.label}
                        onChange={handleConfigBusca}
                        options={config.filtros.servicosConcluidos.periodo.opcoes}
                        obrigatorio={config.filtros.servicosConcluidos.periodo.obrigatorio}
                        value={valores.periodo}
                    />
                </div>
                {intervalo && <Zoom in={true} style={{ transitionDelay: 0 }}>
                    <div>
                        <div className="mt-3">
                            <Campo
                                id="dataInicial"
                                tipo="date"
                                label="Data Inicial"
                                value={valores.inicio ?? ""}
                                onChange={handleConfigBusca}
                                obrigatorio
                            />
                        </div>
                        <div className="mt-3">
                            <Campo
                                id="dataFinal"
                                tipo="date"
                                label="Data Final"
                                value={valores.fim ?? ""}
                                onChange={handleConfigBusca}
                                obrigatorio
                            />
                        </div>
                    </div>
                </Zoom>}
                <div className="mt-3">
                    <Campo
                        id="formaPgto"
                        tipo="select"
                        label={config.filtros.servicosConcluidos.formasPgto.label}
                        onChange={handleConfigBusca}
                        options={config.filtros.servicosConcluidos.formasPgto.opcoes}
                        obrigatorio={config.filtros.servicosConcluidos.formasPgto.obrigatorio}
                        value={valores.formaPgto}
                    />
                </div>

                <div className="g-0 mt-3">
                    <button className="w-full" onClick={() => {
                        setPage(1)
                        buscarConcluidos()
                    }
                    }>Buscar</button>
                </div>

            </div>
            {Object.keys(totais).length > 0 && <Zoom
                className="mt-3"
                in={true}
            >
                <div>
                    {totalPages > 1 && <div className="flex justify-center mb-3">
                        <Pagination
                            sx={{
                                backgroundColor: "transparent",
                                filter: "drop-shadow(none)"
                            }}
                            page={page}
                            count={totalPages}
                            onChange={(e, val) => {
                                setPage(val)
                            }} />
                    </div>}
                    {forma && <Card className="!bg-blue-500 !text-white !p-4 !mb-4">
                        <div className="flex justify-between">
                            <MdInfo size={55} className="me-3" />
                            {forma}
                        </div>
                    </Card>}

                    <Card className="!bg-green-500 !text-white !p-4">
                        <div className="flex justify-between">
                            <div>
                                Serviços concluídos:
                            </div>
                            <div>
                                {totais.concluidos}
                            </div>
                        </div>
                        {totais.kmTotal && <div className="flex justify-between">
                            <div>
                                Total KM:
                            </div>
                            <div>
                                {totais.kmTotal}
                            </div>
                        </div>}
                        <div className="flex justify-between">
                            <div>
                                Total Valor:
                            </div>
                            <div>
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format(totais.valores)}
                            </div>
                        </div>
                    </Card>
                </div>
            </Zoom>}

            <div className="mt-3 pb-3">
                {listaConcluidos}
            </div>
        </div>

        {servicoSelecionado && (
            <Dialog
                open={!!servicoSelecionado}
                onClose={() => setServicoSelecionado(null)}
                fullWidth
                maxWidth={false}
                scroll="body" // permite que o conteúdo role, sem travar o modal
                PaperProps={{
                    className: "p-3 rounded-xl",
                    sx: {
                        width: '95%',
                        maxWidth: '1100px',
                        borderRadius: '12px',
                        marginLeft: '0rem', // <-- move o modal para a esquerda
                        marginRight: 'auto', // <-- garante alinhamento com deslocamento
                    }
                }}
            >
                <DialogTitle disableTypography className="!px-1 !py-1">
                    <div className="flex justify-between items-center w-full">
                        <span className="text-xl font-normal">#{servicoSelecionado?.["s.id"]}</span>
                        <IconButton
                            onClick={() => setServicoSelecionado(null)}
                            className="text-gray-600"
                        >
                            <MdClose size={24} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContentText dividers className="space-y-3">
                    <p className="text-gray-500">Lista de endereços</p>

                    {servicoSelecionado?.enderecos?.map((endereco) => (
                        <CardEndereco
                            key={endereco["e.id"]}
                            id={endereco["es.ponto"]}
                            endereco={endereco["e.rua"]}
                            observacao={endereco["e.observacao"] ?? endereco["e.responsavel"]}
                            icone
                        />
                    ))}
                </DialogContentText>
            </Dialog>

        )}
    </>
}